var AutocompleteCollection = (function (app) {

    var AutocompleteModel = Backbone.Model.extend({
        idAttribute: "id",
        initialize: function () {
            this.set('selected', false);
        }
    });

    var AutocompleteCollection = Backbone.Collection.extend({
        model: AutocompleteModel,
        selectNext: function() {
            var selectedIndex = this._getSelectedIndex();
            if (selectedIndex === -1) {
                selectedIndex = 0;
            } else {
                this.models[selectedIndex].set('selected', false);
                selectedIndex = selectedIndex + 1;
                if (selectedIndex === this.length) {
                    selectedIndex = 0;
                }
            }
            this.models[selectedIndex].set('selected', true);
        },
        selectPrev: function() {
            var selectedIndex = this._getSelectedIndex();
            if (selectedIndex === -1) {
                selectedIndex = this.length - 1;
            } else {
                this.models[selectedIndex].set('selected', false);
                selectedIndex = selectedIndex - 1;
                if (selectedIndex < 0) {
                    selectedIndex = this.length - 1;
                }
            }
            this.models[selectedIndex].set('selected', true);
        },
        _getSelectedIndex: function() {
            return this.models.findIndex(function(m) {
                return m.get('selected');
            });
        },
        getSelectedDescription: function() {
            var selectedIndex = this._getSelectedIndex();
            if (selectedIndex >= 0) {
                return this.models[selectedIndex].get('description');
            }
            return null;
        }
    });

    return AutocompleteCollection;
})(app);